import Name from "./name";
import Email from "./email";
import Status from "./status";

export default function Details() {
  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12">
        <Name />
      </div>
      <div className="col-span-12">
        <Email />
      </div>
      <div className="col-span-12">
        <Status />
      </div>
    </div>
  );
}
